import React, { useEffect, useState } from 'react'
import { isEmpty } from 'libraries/lodash'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import IconButton from '@material-ui/core/IconButton'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { toHtml } from 'front-end-core/helpers/xml'
import { htmlText } from 'helpers/htmlText'
import { CopyLinkToClipboardButton } from 'pages/currentawarenessarticle/IconButtons'
import { SlideBox, TransitionGroup } from 'components/shared/transitions'
import Xml from 'components/shared/Xml'
import TealToolTip from 'components/TealToolTip'

const CommentHeader = ({
  previousReference,
  commentReference,
  commentPreview,
  togglePreview,
  show,
  commentPath,
  isLast,
  qaCommentMap,
  setAnnotationsLoaded
}) => {
  const [content, setContent] = useState()

  useEffect(() => {
    if (!isEmpty(commentReference)) {
      if (!isEmpty(commentReference.content)) {
        // Legisislation
        setContent(commentReference.content)
      } else {
        // QA
        if (!isEmpty(qaCommentMap) && qaCommentMap.has(commentReference.id)) {
          const { answer } = qaCommentMap.get(commentReference.id)
          setContent(toHtml(answer))
        }
      }
    }
  }, [commentReference, qaCommentMap])

  return (
    (!previousReference || commentReference.id !== previousReference.id) && (
      <div className='mb6 mt4'>
        <ContentTitle
          {...commentReference}
          onToggle={commentPreview !== 'show' && togglePreview}
          {...{ show, isLast, setAnnotationsLoaded }}
        />
        {commentPath && <ContentPath path={commentPath} />}
        <TransitionGroup component='div'>
          {content && (show || commentPreview === 'show') && (
            <SlideBox>
              <Content {...{ content }} />
            </SlideBox>
          )}
        </TransitionGroup>
      </div>
    )
  )
}

export default CommentHeader

const ContentPath = ({ path }) => (
  <div className='flex items-center flex-wrap w-100 teal'>
    {path.map(({ title, link }, index) => (
      <div key={index} className='flex items-center'>
        {index !== 0 && (
          <ArrowRightIcon className='mh2 w7' />
        )}
        <a href={link} className='hover-underline no-underline f7'>
          <span>{htmlText(title)}</span>
        </a>
      </div>
    ))}
  </div>
)
const ContentTitle = ({ content, title, link, onToggle, show, commentPreview, permaLink, isLast, setAnnotationsLoaded }) => {
  useEffect(() => {
    setAnnotationsLoaded(isLast)
  }, [isLast, setAnnotationsLoaded])

  if (!title) return null

  return (
    <div className='flex items-center justify-between'>
      <span className='fw6'>
        {htmlText(title)}
      </span>
      <div className='mh5 flex items-center'>
        {onToggle && content && (
          <TealToolTip
            title={show ? 'Hide content' : 'Show content'}
            placement='bottom'
          >
            <IconButton onClick={onToggle} size='small' className='outline-0'>
              <div className='icon-preview-toggle-container cadet-blue'>
                {show ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </div>
            </IconButton>
          </TealToolTip>
        )}
        <CopyLinkToClipboardButton link={permaLink} dataClipboardText={permaLink} size='small' toolTipPlacement='bottom' />
      </div>
    </div>
  )
}

const Content = ({ content }) => (
  <div className='comment-content content-view'>
    <Xml component='div' className='fc-qa' render={content} />
  </div>
)
